module.exports = __webpack_public_path__ + "img/Patryk.f382d076.jpg";